import RateSelect from './RateSelect'

export default RateSelect
